import { c as _c } from "react/compiler-runtime";
import { Link } from "@flat-ui";
import { useLanguage } from "@hooks/use-language";
import { ExternalLinkEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The available links */

/** Links to external pages used in the application */
export const AvailableLinks = {
  /** Links to the create new project help page */
  createNewProjectHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/3569568-how-to-create-a-new-project-in-the-holobuilder-enterprise-dashboard`,
  /** Links to the managing groups help page */
  managingGroupsHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/2547401-managing-groups-in-the-enterprise-dashboard`,
  /** Links to the video mode help page */
  videoModeHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/6592025-how-to-capture-with-holobuilder-videomode-in-the-jobwalk-app`,
  /** Links to the 2d photos help page */
  photos2dHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/3548889-how-to-place-2d-photos-directly-on-your-sheet-in-the-jobwalk-app`,
  /** Link to the HoloBuilder permissions & roles help page */
  permissionsLevelsHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/2437877-permissions-roles-in-the-dashboard`,
  /** Link to the Sphere XG workspace roles help page */
  workspaceRolesHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/9626212-permission-roles-workspace-roles-in-sphere-xg`,
  /** Link to the Sphere XG project roles help page */
  projectRolesHelp: languageCode => `https://help.holobuilder.com/${languageCode}/articles/9626328-permission-roles-project-roles-in-sphere-xg`,
  /** Link to the blink launch */
  blinkLaunch: languageCode => {
    // For the English language, we don't need to add the language code to the URL,
    // for the rest we use the same language code as in the app
    const languageParam = languageCode === "en" ? "" : languageCode;
    return `https://blink.faro.com/${languageParam}?utm_source=HB_SXG_PopUp&utm_medium=syndicatedcontent&utm_campaign=NPI_Blink_HoloBuilder_Backlinks&cid=701Pl00000aA4s3IAC&ls=Display%20Advertising&pint=Imaging%20Laser%20Scanner&mc=0000204&vrt=AEC&lcs=Requested%20More%20Info`;
  },
  /** Link to the floor plan generation help page */
  floorPlanGeneration: () => "https://www.holobuilder.com/content-type/article/transform-your-3d-scan-data-into-2d-floor-plans/?utm_source=product&utm_medium=web&utm_campaign=2025-floor-plans",
  /** Link to the Sphere XG app (named HoloBuilder 360 photo site documentation) in Procore App store */
  procoreAppStore: () => "https://marketplace.procore.com/apps/holobuilder-360-photo-site-documentation",
  /** Link to a Procore article about how to install a 3rd party app in a Procore account */
  procoreAppStoreArticle: () => "https://support.procore.com/products/online/user-guide/company-level/admin/tutorials/install-app-from-marketplace",
  /** Link to a Autodesk article about how to install a 3rd party app in a Autodesk account */
  autodeskAppStoreArticle: () => "https://www.autodesk.com/blogs/construction/app-gallery-autodesk-construction-cloud",
  accProcoreIntegration: () => "https://www.holobuilder.com/integrations?utm_source=product&utm_medium=web&utm_campaign=2025-integration",
  /** Link to the article about the ACC integration with Sphere XG */
  sphereXGAccIntegration: () => "https://www.holobuilder.com/autodesk-construction-cloud",
  /** Link to the article about the Procore integration with Sphere XG */
  sphereXGProcoreIntegration: () => "https://www.holobuilder.com/procore",
  /** Link to the article about the Drone Data integration with Sphere XG */
  droneData: () => "https://help.holobuilder.com/en/articles/14838323-getting-started-with-drone-data-beta"
};
/** Navigate to provided link when user clicks on the text */
export function ExternalLinks(t0) {
  const $ = _c(15);
  const {
    text: t1,
    sx: t2,
    link,
    trackEventProps
  } = t0;
  const text = t1 === undefined ? "Learn more" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sx = t3;
  const {
    currentLanguage
  } = useLanguage();
  const {
    trackEvent
  } = useTrackEvent();
  let t4;
  if ($[2] !== trackEvent || $[3] !== trackEventProps) {
    t4 = () => {
      if (trackEventProps) {
        trackEvent({
          name: ExternalLinkEvents.openExternalLink,
          props: trackEventProps
        });
      }
    };
    $[2] = trackEvent;
    $[3] = trackEventProps;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== currentLanguage.code || $[6] !== link) {
    t5 = AvailableLinks[link](currentLanguage.code);
    $[5] = currentLanguage.code;
    $[6] = link;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== sx) {
    t6 = {
      ...sx
    };
    $[8] = sx;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== text) {
    t7 = <Link onClick={t4} href={t5} target="_blank" rel="noopener noreferrer" sx={t6}>{text}</Link>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = text;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}